export default async (injectString) => {
  console.log('createModalString');
  const tmpModat = await fetch('/assets/template/modalFrame.html')
    .then(res => res.text())
    .then(res => res.trim().replace(/\n\s*/g, ''));

  return tmpModat.replace('{{ details }}', injectString);
}
